import ReactCountryFlag from 'react-country-flag';
import type { ExtendedViewership } from '../types';

export function getStationCountryRenderer({
  data,
}: {
  data: ExtendedViewership;
}) {
  const station = data.station ?? data.watchStation;
  return (
    <div className="station__country">
      <ReactCountryFlag countryCode={station?.country} />
      <span>{station?.country}</span>
    </div>
  );
}
